import React, { useRef } from 'react';
import { Popover, MenuItem, Typography, Box, Avatar } from '@mui/material';
import { getInitials } from '@/utils/getInitials';

export const CollaboratorsList = ({ collaborators, description, anchorEl, setAnchorEl, quill}) => {
  const popoverRef = useRef(null);

  const handleCollaboratorSelect = (collaborator) => {
    const tag = `@${collaborator.name}`;
    const selection = quill.getSelection();
    const index = selection ? selection.index : quill.getLength();

    if (quill) {
      const currentText = quill.getText();
      const lastAtIndex = currentText.lastIndexOf('@');
      const containsAt = lastAtIndex >= 0 && (index - lastAtIndex) <= 1;

      if (containsAt) {
        const startIndex = lastAtIndex;
        const endIndex = index;

        quill.deleteText(startIndex, endIndex - startIndex);

        quill.clipboard.dangerouslyPasteHTML(startIndex, `<span style="color:blue">${tag}</span>&nbsp;`);
        quill.setSelection(startIndex + tag.length + 6);
      } else {
        quill.clipboard.dangerouslyPasteHTML(index, `<span style="color:blue">${tag}</span>&nbsp;`);
        quill.setSelection(index + tag.length + 6);
      }

      setAnchorEl(null);
    }
  };






  const open = Boolean(anchorEl);

  return (
    <>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        ref={popoverRef}
        sx={{
          '& .MuiPopover-paper': { background: 'transparent', maxWidth: '30%', boxShadow: 'none', border: 'none' },
        }}
      >
        <Box
          sx={{
            border: '1px solid #D1D1D1',
            borderRadius: '8px',
            backgroundColor: '#F9FAFB',
            padding: '4px',
            display: 'flex',
            flexDirection: 'column',
            gap: '5px',
            width: '90%',
            maxHeight: '200px',
            overflowY: 'auto',
            m: '0 auto',
          }}
        >
          {collaborators.map((collaborator) => {
            const tag = `@${collaborator.name}`;
            const isTagged = description.includes(tag);
            return (
              <MenuItem key={collaborator.id} onClick={() => handleCollaboratorSelect(collaborator)} sx={{width: '100%'}}>
                <Avatar
                  sx={{
                    bgcolor: '#2055ff',
                    color: 'white',
                    border: '1px solid #D1D1D1',
                    height: '25px',
                    width: '25px',
                    fontSize: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    lineHeight: 1,
                  }}
                >
                  {getInitials(collaborator?.name || 'Guest')}
                </Avatar>
                <Typography variant="body1" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', marginLeft: '10px', fontSize: '16px', fontWeight: '500' }}>
                  {collaborator.name}
                </Typography>
                {isTagged && <i className="fa fa-check" style={{ color: '#2055ff', marginLeft: 'auto' }} />}
              </MenuItem>
            );
          })}
        </Box>
      </Popover>
    </>
  );
};
